module.exports = __webpack_public_path__ + "img/img_11.bbc9e2c4.png";